/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "../../styles/containers/CreateUsers.scss";
import Form from "../../components/Form";
import { connect } from "react-redux";
import { createUserValidation } from "../../validation";
import { Formik } from "formik";
import { createUser, createuser } from "../../store/actions/usersActions";
import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router";
import Loader from "../../components/Loader";
import moment from "moment";
const createButton = { title: "Create", type: "submit" };

function Users({
  createUser,
  isPost,
  message,
  error,
  success,
  createuser,
  isFetchedUser,
  fetchedUserSuccess,
  fetchedUser,
  fetchedUserError,
  isFetchedParks,
  fetchedParksSuccess,
  fetchedParks,
  fetchedParksError,
  parkID,
}) {
  const [loading, setLoading] = useState(false);

  const [positionOptions] = useState([
    { value: "", label: "Select position" },
    { value: "owner", label: "Owner" },
    { value: "operation manager", label: "Operation Manager" },
    { value: "technician", label: "Technician" },
    { value: "operator", label: "Operator" },
  ]);
  const [languageOptions] = useState([
    { value: "", label: "Select language" },
    { value: "deutsch", label: "Deutsch" },
    { value: "english", label: "English" },
    { value: "francais", label: "Francais" },
    { value: "thai", label: "Thai" },
  ]);
  const [parkOptions, setParkOptions] = useState([
    { value: "", label: "Select Park" },
  ]);
  const [createUserForm, setCreateUserForm] = useState([
    {
      input: "text",
      type: "text",
      placeholder: "First Name",
      name: "firstName",
      id: "firstName",
    },
    {
      input: "text",
      type: "text",
      placeholder: "Last Name",
      name: "lastName",
      id: "lastName",
    },
    {
      input: "text",
      type: "date",
      placeholder: "Date of birth",
      name: "dateOfBirth",
      id: "dateOfBirth",
      max: new Date(),
    },
    {
      input: "text",
      type: "email",
      placeholder: "Email",
      name: "email",
      id: "email",
    },
    {
      input: "text",
      type: "password",
      placeholder: "Password",
      name: "password",
      id: "password",
    },
    {
      input: "dropdown",
      placeholder: "Select position",
      options: positionOptions,
      defaultValue: positionOptions[0],
      name: "position",
      id: "position",
    },
    {
      input: "dropdown",
      type: "dropdown",
      placeholder: "Select language",
      options: languageOptions,
      defaultValue: languageOptions[0],
      name: "language",
      id: "language",
    },
  ]);
  const [loadForm, setLoadForm] = useState(false);

  let history = useHistory();

  useEffect(() => {
    if (!isFetchedUser) setLoadForm(true);
  }, []);

  useEffect(() => {
    if (fetchedUserSuccess && isFetchedUser) {
      let parkField = createUserForm.some(
        (field) => field.input === "dropdown" && field.id === "park"
      );
      let rightsField = createUserForm.some(
        (field) => field.input === "dropdown" && field.id === "rights"
      );
      if (fetchedUser.rights.toLowerCase() === "superadmin") {
        setCreateUserForm((previousData) => {
          let preData = [...previousData];
          if (!rightsField)
            preData.push({
              input: "dropdown",
              type: "dropdown",
              placeholder: "Select right",
              options: [
                { value: "", label: "Select rights" },
                { value: "SuperAdmin", label: "Super Admin" },
                { value: "Admin", label: "Admin" },
                { value: "Technician", label: "Technician" },
                { value: "ReadOnly", label: "Read Only" },
              ],
              name: "rights",
              id: "rights",
            });
          if (!parkField)
            preData.push({
              input: "dropdown",
              placeholder: "Select park",
              options: parkOptions,
              name: "park",
              id: "park",
            });

          return preData;
        });
      } else {
        setCreateUserForm((previousData) => {
          let preData = [...previousData];
          if (!rightsField)
            preData.push({
              input: "dropdown",
              type: "dropdown",
              placeholder: "Select rights",
              options: [
                { value: "", label: "Select rights" },
                { value: "Admin", label: "Admin" },
                { value: "Technician", label: "Technician" },
                { value: "ReadOnly", label: "Read Only" },
              ],
              name: "rights",
              id: "rights",
            });
          return preData;
        });
      }
      setLoadForm(false);
    } else if (fetchedUserError) {
      setLoadForm(false);
    }
  }, [isFetchedUser]);

  useEffect(() => {
    if (fetchedParksSuccess && isFetchedParks) {
      if (fetchedParks.length) {
        let options = [{ value: "", label: "Select Park" }];
        fetchedParks.map((park) =>
          options.push({ value: park.id, label: park.name })
        );
        setCreateUserForm((previousData) => {
          let preData = [...previousData];
          preData.filter((field) =>
            field.id === "park" ? (field.options = options) : ""
          );
          return preData;
        });
        setParkOptions(options);
      }
    } else if (fetchedParksError) {
      toast.error(`Error in getting of parks ${fetchedParksError}`);
    }
  }, [isFetchedParks && isFetchedUser]);

  useEffect(() => {
    if (isPost) setLoading(false);
    if (success && isPost) {
      createuser();
      toast.success(message);
      history.push("/view-users");
    }
  }, [isPost]);

  const handleSubmit = (formvValues) => {
    const {
      firstName,
      lastName,
      dateOfBirth,
      email,
      password,
      position,
      language,
      rights,
      park,
    } = formvValues;

    const data = {
      first_name: firstName,
      last_name: lastName,
      date_of_birth: moment(dateOfBirth).format("YYYY-MM-DD"),
      email,
      password,
      position: position.value,
      rights: rights.value,
      language: language.value,
      groupname: rights.value,
      park_id: park.value ? park.value.toString() : parkID,
    };
    createUser(data);
    setLoading(true);
  };

  const values = {
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    email: "",
    password: "",
    position: "",
    rights: "",
    language: "",
    park: "",
  };

  return (
    <div
      className="CreateUsers"
      style={loadForm ? { height: "100vh" } : { height: "100%" }}
    >
      {loadForm ? (
        <Loader />
      ) : (
        <>
          <h1 className="heading-1">Create User</h1>
          <Formik
            initialValues={values}
            validationSchema={createUserValidation}
            onSubmit={handleSubmit}
          >
            {({
              handleSubmit,
              handleChange,
              setFieldTouched,
              setFieldValue,
              values,
              touched,
              errors,
              getFieldMeta,
            }) => {
              const onInputChange = (name, e, type) => {
                if (type === "dropdown") {
                  if (
                    e.value.toString().toLowerCase() === "superadmin" &&
                    name === "rights"
                  ) {
                    if (
                      !getFieldMeta("park")?.value ||
                      !getFieldMeta("park")?.value.value
                    )
                      setFieldValue("park", parkOptions[1], true);

                    setCreateUserForm((previousData) => {
                      let preData = [...previousData];
                      preData.filter((field) =>
                        field.id === "park" ? (field.hide = true) : ""
                      );
                      return preData;
                    });
                  } else if (
                    e.value.toString().toLowerCase() !== "superadmin" &&
                    name === "rights"
                  ) {
                    setCreateUserForm((previousData) => {
                      let preData = [...previousData];
                      preData.filter((field) =>
                        field.id === "park" ? (field.hide = false) : ""
                      );
                      return preData;
                    });
                  }
                  setFieldValue(name, e, true);
                } else if (name === "dateOfBirth")
                  setFieldValue(
                    "dateOfBirth",
                    // moment(e).format("YYYY-MM-DD"),
                    e,
                    true
                  );
                else {
                  e.persist();
                  handleChange(e);
                }
                setFieldTouched(name, true, false);
              };
              return (
                <Form
                  button={createButton}
                  fields={createUserForm}
                  id="Create-User"
                  handleFormData={onInputChange}
                  data={values}
                  submitForm={handleSubmit}
                  touched={touched}
                  errors={errors}
                  errorMessage={error}
                  loading={loading}
                />
              );
            }}
          </Formik>
        </>
      )}
      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    isPost: state?.users?.createUser?.isPost,
    error: state?.users?.createUser?.error,
    message: state?.users?.createUser?.message,
    success: state?.users?.createUser?.success,
    isFetchedUser: state?.users?.getUser?.isFetched,
    fetchedUserSuccess: state?.users?.getUser?.success,
    fetchedUserError: state?.users?.getUser?.error,
    fetchedUser: state?.users?.getUser?.user,
    isFetchedParks: state?.parks?.isFetched,
    fetchedParksSuccess: state?.parks?.success,
    fetchedParksError: state?.parks?.error,
    fetchedParks: state?.parks?.parks,
    parkID: state?.users?.getUser?.user.park_id,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createUser: (data) => dispatch(createUser(data)),
    createuser: () => dispatch(createuser()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);
